export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/b94cdee409f55382a26c8aa8c74f2625.png";